var _style, _metadata, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F0BE;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0,
    y: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,23.6c-0.7,0.8-1.5,1.4-2.3,1.8s-1.8,0.6-2.8,0.6s-1.9-0.2-2.7-0.6s-1.6-0.9-2.2-1.6s-1.1-1.5-1.4-2.4 s-0.5-1.9-0.5-2.9c0-1.1,0.2-2.1,0.6-3.1s0.9-1.8,1.6-2.5s1.5-1.3,2.5-1.7s2-0.6,3.2-0.6c1.3,0,2.5,0.2,3.6,0.7s1.9,1.2,2.7,2.1 s1.3,2.1,1.7,3.5s0.6,3,0.6,4.8c0,2-0.2,3.8-0.6,5.3s-1,2.8-1.8,3.8S26.1,33,25,33.5s-2.3,0.8-3.7,0.8s-2.5-0.3-3.5-0.8 s-1.8-1.2-2.3-1.9c-0.5-0.8-0.8-1.5-0.8-2.2c0-0.4,0.2-0.8,0.5-1.2s0.7-0.5,1.2-0.5c0.5,0,0.9,0.1,1.2,0.4s0.6,0.6,0.8,1.1 c0.2,0.6,0.6,1.1,1.1,1.5s1.1,0.6,1.8,0.6c0.6,0,1.2-0.1,1.7-0.5s1-0.7,1.4-1.3C25.2,28.4,25.7,26.4,25.8,23.6L25.8,23.6z  M25.5,18.8c0-0.7-0.1-1.4-0.3-2s-0.5-1.1-0.8-1.6s-0.8-0.8-1.2-1s-1-0.4-1.6-0.4c-1,0-1.8,0.4-2.5,1.3c-0.7,0.9-1,2-1,3.4 s0.3,2.5,1,3.3s1.6,1.2,2.6,1.2c0.6,0,1.3-0.2,1.9-0.5s1.1-0.8,1.4-1.5S25.4,19.7,25.5,18.8L25.5,18.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt9);
export default __webpack_public_path__ + "static/media/CT9.0e66cf4a4011eac13207bd185a39bf27.svg";
export { ForwardRef as ReactComponent };